import moment from 'moment-timezone';

class DataVaultItemClass {

    ai_enabled = true;
    date = null;
    id = null;
    last_modified = null;
    metadata = null;
    name = null;
    provider = null;
    requiem_processing_status = null;
    user_id = null;
    
    constructor() {
        return this;
    }

	create = (props = {}) => {
        this.ai_enabled = props.ai_enabled;
        this.date = props.date && moment.utc(props.date).local();
        this.id = props.id;
        this.last_modified = props.last_modified && moment.utc(props.last_modified).local();
        this.metadata = props.metadata;
        this.name = props.name;
        this.provider = props.provider;
        this.requiem_processing_status = props.requiem_processing_status;
        this.user_id = props.user_id;
        return this;
	}
}

export default {
    create: props => new DataVaultItemClass().create(props),
    new: () => new DataVaultItemClass()
}
